import { render, staticRenderFns } from "./smartElderly.vue?vue&type=template&id=3c8d86ed&scoped=true"
import script from "./smartElderly.vue?vue&type=script&lang=js"
export * from "./smartElderly.vue?vue&type=script&lang=js"
import style0 from "./smartElderly.vue?vue&type=style&index=0&id=3c8d86ed&prod&scoped=true&lang=css"
import style1 from "./smartElderly.vue?vue&type=style&index=1&id=3c8d86ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d86ed",
  null
  
)

export default component.exports